import { FC } from 'react';
import classNames from 'classnames';

import { getFormattedCountdownDate, useCountdown } from 'hooks/useCountdown';

type RequestsCountdownProps = {
  expiration: string;
  className?: string;
  textType?: 'expiresIn' | 'left';
};

export const RequestsCountdown: FC<RequestsCountdownProps> = ({ expiration, className, textType = 'expiresIn' }) => {
  const countdown = useCountdown(expiration);
  const formattedCountdownDate = getFormattedCountdownDate(countdown, expiration, 'Expired');

  const content =
    textType === 'expiresIn' ? (
      <span>EXPIRES IN {formattedCountdownDate}</span>
    ) : (
      <span>{formattedCountdownDate} LEFT</span>
    );

  return <div className={classNames('letter-spacing-08 text-uppercase', className)}>{content}</div>;
};
